import { createContext, useContext } from "react";
import type { AuthUser } from "@workspace/api-client-react";

interface SignInModalState {
  open: boolean;
  reason?: string;
  onSuccess?: (user: AuthUser) => void;
}

export interface AuthContextValue {
  user: AuthUser | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<AuthUser>;
  signUp: (email: string, password: string, handle: string) => Promise<AuthUser>;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
  /** Complete a sign-in performed outside the form flow (e.g. Google). */
  completeExternalSignIn: (user: AuthUser) => void;
  requireSignIn: (opts?: {
    reason?: string;
    onSuccess?: (user: AuthUser) => void;
  }) => void;
  closeSignInModal: () => void;
  signInModal: SignInModalState;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
